import { Form, Row } from "antd";
import React from "react";
import CustomInput from "../../../components/common/CustomInput";

const BankAccountDetailFirstForm = ({ name, mapIndex, ...restField }) => {
    return (
        <>
            <Row>

                <Form.Item className='w-100' label="Customer Name" name={[name, "reportName"]} {...restField} required={true} rules={[{ required: true, message: "Please enter a report name" }]}>

                    <CustomInput placeholder={"Enter Report Name"} disabled={mapIndex > 0} autoComplete="new-password"
                    />
                </Form.Item>
            </Row>
            {/* <Row>
                <Form.Item className='w-100' label="Reference ID" name={[name, "referenceId"]} {...restField} required={false} rules={[{ required: false, message: "Please enter a reference ID" }]}>
                    <CustomInput placeholder={"Enter Reference ID"} disabled={mapIndex > 0} />
                </Form.Item>
            </Row> */}
            <Row>
                <Form.Item className='w-100' label="Created By" name={[name, "createdBy"]} {...restField} required={false} rules={[{ required: false, message: "Please enter a creator" }]}>
                    <CustomInput style={{ background: "#0000000A !important" }} disabled placeholder={"Created By"} />
                </Form.Item>
            </Row>
            <Row>
                <Form.Item className='w-100' label="Created On" name={[name, "createdOn"]} {...restField} required={false} rules={[{ required: false, message: "Please enter a last updated by" }]}>
                    <CustomInput style={{ background: "#0000000A !important" }} disabled placeholder={"Created On"} />
                </Form.Item>
            </Row>
        </>
    );
}

export default BankAccountDetailFirstForm;